import React, { Component } from 'react';
import { Input, Button } from './';
import CSSModules from 'react-css-modules';
import style from './file-button.scss';
import pick from 'lodash/pick';

@CSSModules(style)
export default class FileButton extends Component {
  render() {
    return (
      <div styleName="root">
        <Button
          submit={false}
          onClick={() => this.inputComponent.click()}
          {...pick(this.props, 'type', 'size')}
        >
          {this.props.children}
        </Button>

        <Input
          onLoad={component => this.inputComponent = component}
          type="file"
          {...pick(this.props, 'onChange', 'multiple', 'onClick', 'accept')}
          forceOnChange={true}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/file-button.js